// <!-- GRACE:MODULE_START name="ui_entrypoint" -->
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// <!-- GRACE:MODULE_END name="ui_entrypoint" -->
